import { Box, Button, Container, Typography } from '@mui/material'

import { Activity } from 'react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorPage = ({
  status = 404,
  title = 'Page Not Found',
  message = 'The page you are looking for does not exist.',
  showBackButton = true,
}) => {
  const navigate = useNavigate()

  const errorInfo = {
    404: {
      title: 'Page Not Found',
      message: 'The page you are looking for does not exist.',
    },
    403: {
      title: 'Access Denied',
      message: 'You do not have permission to access this resource.',
    },
    429: {
      title: 'Too Many Requests',
      message: 'Please wait a moment before trying again.',
    },
    500: {
      title: 'Server Error',
      message: 'An unexpected error occurred. Please try again later.',
    },
  }

  const currentError = errorInfo[status] || errorInfo[404]

  return (
    <Container>
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant="h1"
          color="primary"
          sx={{ fontSize: '6rem', fontWeight: 'bold' }}
        >
          {status}
        </Typography>
        <Typography variant="h4" gutterBottom>
          {title || currentError.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {message || currentError.message}
        </Typography>
        <Activity mode={showBackButton ? 'visible' : 'hidden'}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
          >
            Go Home
          </Button>
        </Activity>
      </Box>
    </Container>
  )
}

export default ErrorPage
